import React from 'react';

import {
  Typography
} from '@mui/material';

import GoBack from 'components/GoBack';

const Photos = () => {
  return (
    <>
      <GoBack />
      <Typography variant="h5">Não temos fotos disponíveis no momento</Typography>
    </>
  )
}

export default Photos